import { Tabs } from "@ubnt/ui-components/Tabs";
import styled from "styled-components";

export const StyledTabs = styled(Tabs)`
  .tabs {
    background: ${({ theme }) => theme.colors.neutral00};
    border: 1px solid ${({ theme }) => theme.colors.neutral04};
  }

  .tab {
    padding: 4px 16px;

    > span {
      display: flex;
      align-items: center;
      color: ${({ theme }) => theme.colors.neutral09};

      svg {
        bottom: 0;
        color: ${({ theme }) => theme.colors.neutral08};
        transition: color 0.15s linear;
      }
    }

    &:hover:not(.selected-tab) {
      > span {
        color: ${({ theme }) => theme.colors.ublue06} !important;

        svg {
          color: ${({ theme }) => theme.colors.ublue06};
        }
      }
    }
  }

  .selected-tab {
    background: ${({ theme }) => theme.colors.ublue06} !important;

    > span {
      color: ${({ theme }) => theme.colors.neutral00} !important;

      svg {
        color: ${({ theme }) => theme.colors.neutral00};
      }
    }
  }
`;
